import { renderToStaticMarkup } from "react-dom/server";
import { getCitationFilePath } from "../../api";
import ReactMarkdown from 'react-markdown';

type HtmlParsedAnswer = {
    answerHtml: string;
    citations: string[];
    followupQuestions: string[];
    isMarkdown: boolean;
};

export function parseAnswerToHtml(answer: string, onCitationClicked: (citationFilePath: string) => void): HtmlParsedAnswer {
    const citations: string[] = [];
    const followupQuestions: string[] = [];

    // Check if the answer contains markdown syntax
    const hasMarkdown = /[#*_`\[\]()~]/.test(answer) || answer.includes('**') || answer.includes('##') || answer.includes('###');

    // Extract any follow-up questions that might be in the answer
    let parsedAnswer = answer.replace(/<<([^>>]+)>>/g, (match, content) => {
        followupQuestions.push(content);
        return "";
    });

    // trim any whitespace from the end of the answer after removing follow-up questions
    parsedAnswer = parsedAnswer.trim();

    // const match = parsedAnswer.match(/([\s\S]*?)(\n\n[A-Z].*?\?)\s*$/);

    // if (match) {
    //     followupQuestions.push(match[2].trim());
    //     parsedAnswer = match[1].trim();

    // }

    // If it's markdown, we'll handle it differently in the component
    if (hasMarkdown) {
        return {
            answerHtml: parsedAnswer, // Keep original markdown text
            citations,
            followupQuestions,
            isMarkdown: true
        };
    }

    // Original citation parsing for non-markdown content
    const parts = parsedAnswer.split(/\[([^\]]+)\]/g);

    const fragments: string[] = parts.map((part, index) => {
        if (index % 2 === 0) {
            return part;
        } else {
            let citationIndex: number;
            if (citations.indexOf(part) !== -1) {
                citationIndex = citations.indexOf(part) + 1;
            } else {
                citations.push(part);
                citationIndex = citations.length;
            }

            const path = getCitationFilePath(part);

            return renderToStaticMarkup(
                <a className="supContainer" title={part} onClick={() => onCitationClicked(path)}>
                    <sup>{citationIndex}</sup>
                </a>
            );
        }
    });

    return {
        answerHtml: fragments.join(""),
        citations,
        followupQuestions,
        isMarkdown: false
    };
}
